import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, firstValueFrom, Observable, throwError } from 'rxjs';
import * as jwt_decode from 'jwt-decode';
import { OAuthService } from 'angular-oauth2-oidc';
import { StorageService } from '../services/storage.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';


@Injectable({providedIn: 'root'})
export class TokenInterceptor implements HttpInterceptor {
    dialogTitle: string = "Session.Expired.dialogTitle";
    dialogText: string= "Session.Expired.dialogText";
     dialogButtonConfirm: string= "Session.Expired.dialogButtonConfirm";
   
    
    constructor(private oauthService: OAuthService, private injector: Injector, private _storageService: StorageService, private router: Router, public dialog: MatDialog) { }

    intercept(request: HttpRequest<any>, next: HttpHandler, retry = false): Observable<HttpEvent<any>> {
        let requestToForward = request;
        if (this.oauthService === undefined) {
            this.oauthService = this.injector.get(OAuthService);
        }
        let headers: HttpHeaders = request.headers;
        if (this.oauthService.discoveryDocumentLoaded && this.oauthService.hasValidAccessToken()) {
//            let token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjIxMDZlM2QzZWRlMDQxMWNkZDYxYjBmMmU3ZDgwMzFiIiwidHlwIjoiSldUIn0.eyJuYmYiOjE2NzE1NTIzNTMsImV4cCI6MTY3MTU1NTk1MywiaXNzIjoiaHR0cHM6Ly91YXQtY29ubmVjdDEuZ3MxLmZyIiwiYXVkIjpbImh0dHBzOi8vdWF0LWNvbm5lY3QxLmdzMS5mci9yZXNvdXJjZXMiLCJhY2Nlc0VzcGFjZUNsaWVudCJdLCJjbGllbnRfaWQiOiJhbmd1bGFyY2xpZW50Iiwic3ViIjoiZjQ5YjJhNGEtMTQ1Yy00NWZhLTkyZmQtMzk4ODQ0NmQ5NmM2IiwiYXV0aF90aW1lIjoxNjcxNTI0MDQ1LCJpZHAiOiJsb2NhbCIsIkFzcE5ldC5JZGVudGl0eS5TZWN1cml0eVN0YW1wIjoiUkxZTzRMTk5UWkRVTEk1V0E2T0NPMllJWVBZVVRLQjMiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJ0ZXN0YXV0bzY2NzNAeW9wbWFpbC5jb20iLCJuYW1lIjoidGVzdGF1dG82NjczQHlvcG1haWwuY29tIiwiZW1haWwiOiJ0ZXN0YXV0bzY2NzNAeW9wbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwic2NvcGUiOlsib3BlbmlkIiwicHJvZmlsZSIsImFjY2VzRXNwYWNlQ2xpZW50Il0sImFtciI6WyJwd2QiXX0.UcMxRsKVaXzhZvSOc0rlCRtH5qAnWc7KSUkWu5VlPhLtoubbS65646HrrRfIRUyMtT0Q2G9nnuNhnH4ofTDcmQ7eE7UtoIFxKZ4vmn9m74WcCnBChZygxvmc-5tITnmCJpi1l2qpGQhEIk4ZFxd0hD_-fuujCcfolTFf4aeYd65wESEyO4Uc8NF6hpYOpqbEKEF6L24uZzF41geIyCvdR7Cn7XEK9-wX6rkcWsAfGlBoS_USsEolr2DojDTkG8rRymZRI_Z8iyThfTUGkzYi4yojaDGepNGQS-_jyc3JF8fmBqiPnMYej2KE0GfBR3QKf862LTMQh3Z-TdBEzMOt0g";
            let token = this.oauthService.getAccessToken();

            if (token && token !== "") {
                let tokenValue = "Bearer " + token;
                //requestToForward = request.clone({ setHeaders: { "Authorization": tokenValue } });
                headers = headers.set('Authorization', tokenValue);
                //let tokenGS1 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50TnVtYmVyIjoiQ0xULTAwNDIzMDIiLCJhY2NvdW50TmFtZSI6IlNDSSBRVUFJIFdFU1QiLCJ0eXBlQ29tcHRlIjoiR1MxIEZyYW5jZSIsImVtYWlsIjoidGVzdGF1dG82NjczQHlvcG1haWwuY29tIiwicm9sZSI6IltcImFkbWluaXN0cmF0ZXVyXCIsXCJ1dGlsaXNhdGV1clwiXSIsImdsbiI6IjM3NzAwMjc1MTQwMTUiLCJzaXJlbiI6IjgwMzYwODEyNCIsImZpcnN0bmFtZSI6ImRlbW8xMSIsImxhc3RuYW1lIjoiQXV0bzExIiwiY2l2aWxpdGUiOiJNb25zaWV1ciIsImFjdGl2aXRlIjoiR3Jvc3Npc3RlIC8gTsOpZ29jaWFudCAvIEltcG9ydGF0ZXVyIiwiYWNjZXNzRmljaGVQYXJ0ZW5haXJlIjoiRmFsc2UiLCJjb3VudHJ5IjoiRlJBTkNFIiwiaWRDb21wYW55IjoiMjYxZGM5NjMtMjcwOS00Y2RjLWI3ZDEtODlkMmFlYmE5ZTMwIiwiaWRDb250YWN0IjoiMjc5ZDc4NjEtYjJhMC00Njg5LTQwNTMtMDhkYWFjZmU4ZmVmIiwibmJmIjoxNjcxNTUyMjg5LCJleHAiOjE2NzE2Mzg2ODksImlhdCI6MTY3MTU1MjI4OX0._nNjXePdZyOoRdCDKMR2pD4U-hZd1Pe4zdkUlGcN8uU";
                let tokenGS1 = this._storageService.getGS1Token();

            
                if (!tokenGS1) {
                    tokenGS1 = "";
                } else if (tokenGS1 !== "") {
                    const decodedToken = jwt_decode(tokenGS1)
                    if (decodedToken.gln) {
                        headers = headers.set('GLN', decodedToken.gln);
                    }
                    if (decodedToken.accountNumber) {
                        headers = headers.set('NumCompteGS1', decodedToken.accountNumber);
                    }
                    if (decodedToken.email) {
                        headers = headers.set('EmailUser', decodedToken.email);
                    }
                }
                headers = headers.set('tokenGs1', tokenGS1);
            }
        }
        console.debug(request)

        requestToForward = request.clone({
            headers
        });


        return next.handle(requestToForward).pipe(
            catchError( async (err: Error) => {
                if (err instanceof HttpErrorResponse && err.status === 401) {//here
                    if (this.oauthService.discoveryDocumentLoaded && !retry) {
                        await this.oauthService.tryLogin();
                        return firstValueFrom(this.intercept(requestToForward, next, true));
                    }
                }
                throw err;
            })
        );
    }

    

}